import { api } from "./client";

/**
 * bella-admin-api notifications module — the bell. Everyone signed in, their
 * own rows only (`/v1/notifications/*`).
 */

export interface AdminNotification {
  id: number;
  title: string;
  body: string;
  ticketId: number | null;
  customerId: number | null;
  /** Epoch ms. */
  at: number;
  read: boolean;
}

export interface FollowUpDue {
  ticketId: number;
  number: string;
  title: string;
  personName: string | null;
  /** IST "YYYY-MM-DD HH:mm:ss" as the tickets API writes it. */
  followUpAt: string;
}

export interface NotificationPage {
  items: AdminNotification[];
  unread: number;
  followUpsDue: FollowUpDue[];
}

export interface NotificationCount {
  unread: number;
  followUpsDue: number;
}

export const NOTIFICATION_PAGE_SIZE = 30;

export const notificationKeys = {
  all: ["notifications"] as const,
  count: () => [...notificationKeys.all, "count"] as const,
  list: () => [...notificationKeys.all, "list"] as const,
};

const withSignal = (signal?: AbortSignal) => (signal ? { signal } : {});

export const getNotificationCount = (signal?: AbortSignal) =>
  api.get<NotificationCount>("/notifications/count", withSignal(signal));

/** Keyset: `before` is the smallest id already shown. */
export const getNotifications = (before: number | null, signal?: AbortSignal) => {
  const params = new URLSearchParams({ limit: String(NOTIFICATION_PAGE_SIZE) });
  if (before !== null) params.set("before", String(before));
  return api.get<NotificationPage>(`/notifications?${params}`, withSignal(signal));
};

export const markNotificationsRead = (input: { ids?: number[]; all?: boolean }) =>
  api.post<{ updated: number }>("/notifications/read", input);

export const deleteNotification = (id: number) =>
  api.delete<unknown>(`/notifications/${id}`);
